import Swiper from 'swiper';
import {
  Navigation,
  Thumbs
} from 'swiper';

Swiper.use([Navigation, Thumbs]);
const hasThumbs = document.querySelector('.product-thumbnails') ? true : false;
if (hasThumbs) {
  var swiper = new Swiper(".product-thumbnails", {
    loop: false,
    slidesPerView: 2,
    spaceBetween: 0,
    freeMode: true,
    watchSlidesProgress: true,
  });
}

var swiper2 = new Swiper(".product-featured-image", {
  loop: true,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next-featured",
    prevEl: ".swiper-button-prev-featured",
  },
  thumbs: hasThumbs ? {
    swiper: swiper,
  } : {},
});